/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import Authorization from '../Authorization';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE, FREE_PLAN } from '../../constants';

class TheaterFeature extends Component {
  render() {
    const { feature } = this.props;

    let content = <div />;

    switch (feature.type) {
      case 'checkbox':
        content = (
          <div>
            <span>{feature.name}</span>&nbsp;&nbsp;
            <i
              className={`fa fa-${feature.value ? 'check' : 'times red-icon'}`}
            />
          </div>
        );
        break;
      case 'link':
        content = (
          <div>
            <Authorization deniedPlans={[FREE_PLAN]} allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
              <a target="_blank" href={feature.value} title={feature.name}>
                <i className="fa fa-file-pdf-o" />
                <span>{feature.name}</span>
              </a>
            </Authorization>
            <Authorization allowedPlans={[FREE_PLAN]} denied={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
              <span>
                <i className="fa fa-file-pdf-o" />
                <span>{feature.name}</span>
              </span>
            </Authorization>
          </div>
        );
        break;
      default:
        content = (
          <div>
            <i className="fa fa-user" />
            <span>
              {feature.name}: {feature.value}
            </span>
          </div>
        );
        break;
    }
    return <li className="bordered-right">{content}</li>;
  }
}

export default TheaterFeature;



// WEBPACK FOOTER //
// ./src/components/Features/TheaterFeature.js